import { render, staticRenderFns } from "./ContactAddressSelector.vue?vue&type=template&id=7c87f711"
import script from "./ContactAddressSelector.vue?vue&type=script&lang=js"
export * from "./ContactAddressSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports